import React, { useContext, useEffect } from 'react';

import { Check } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Header from '../../uiParts/Header';
import { gray100, primaryButtonOutlinedColor } from '../../../constants/Colors';
import { headerHeight, spHeaderHeight } from '../../../constants/Location';
import { AuthContext } from '../../../contexts/auth';
import CustomHead from '../CustomHead';

const styles = {
  button: {
    fontSize: '16px',
    fontWeight: '500',
    mt: '80px'
  },
  container: {
    '@media screen and (max-width:600px)': {
      height: `calc( 100vh - ${spHeaderHeight} - 64px)`,
      m: `${spHeaderHeight} auto 0`,
      pt: '64px',
      width: '90%'
    },
    height: `calc( 100vh - ${headerHeight} - 96px )`,
    m: `${headerHeight} auto 0`,
    pt: '96px',
    width: '560px'
  },
  icon: {
    '@media screen and (max-width:600px)': {
      fontSize: '64px'
    },
    fontSize: '80px',
    width: '100%'
  },
  text: {
    color: gray100,
    mt: '24px',
    textAlign: 'center'
  },
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: '500',
    mt: '16px',
    textAlign: 'center'
  },
  primaryButtonOutlinedColor
};

const ProductContactComplete: React.FC = () => {
  const navigate = useNavigate();

  // ログインチェック
  const { isLoggedIn } = useContext(AuthContext);
  useEffect((): void => {
    if (!isLoggedIn) {
      navigate('/auth/login');
      return;
    }
  }, []);

  return (
    <>
      <CustomHead title="建材登録についてお問合せ完了 | CMCOS[コムコス]" />
      <Header />
      <Box sx={styles.container}>
        <Check sx={styles.icon} />
        <Typography sx={styles.title}>お問い合わせが完了しました</Typography>
        <Typography sx={styles.text}>
          回答まで3営業日ほどお待ち下さい。
          <br />
          回答はメールでお送りいたします。
        </Typography>
        <Button
          fullWidth
          onClick={() => navigate('/product/new')}
          sx={[styles.button, styles.primaryButtonOutlinedColor]}
          variant="outlined"
        >
          戻る
        </Button>
      </Box>
    </>
  );
};

export default ProductContactComplete;
